<template>
    <div>
        <div class="mb-1">
            <div v-if="!is_editing">
                <itinerary-item :item="item"></itinerary-item>
            </div>

            <div class="edit-itinerary-item__form-wrapper" v-else>
                <b-form @submit.prevent="onSubmit()">
                    <b-form-group>
                        <label>
                            Title
                        </label>

                        <b-form-input
                            type="text"
                            v-model="form.title"
                            required>    
                        </b-form-input>
                        
                        <label>
                            Time
                        </label>
                    
                        <date-picker 
                            :datestring="form.time" 
                            :config="datepicker.config"
                            @changed="(new_time) => {
                                form.time = new_time;
                            }">
                        </date-picker>
                        
                        <label>
                            Body
                        </label>

                        <b-form-textarea
                            v-model="form.body"
                            required>    
                        </b-form-textarea>
                    </b-form-group>

                    <b-button type="submit" variant="primary">
                        Submit
                    </b-button>
                </b-form>
            </div>

            <div class="text-right">
                <a href="#" class="text-primary font-weight-bold mr-2" @click.prevent="toggleEdit">
                    {{ !is_editing ? "Edit" : "Cancel editing" }}
                </a>

                <a href="#" class="text-danger font-weight-bold" @click.prevent="askDeleteItem">
                    Delete
                </a>
            </div>
        </div>

        <b-modal 
            v-model="show_delete_modal"
            id="delete-modal"
            title="Warning"
            @ok="deleteItem()"
            header-bg-variant="danger"
            header-text-variant="light"
            ok-title="Delete"
            ok-variant="danger">
            Are you sure you want to permanently delete this itinerary item?
        </b-modal>
    </div>
</template>

<script>
    import DatePicker from '@/components/DatePicker.vue';
    import ItineraryItem from '@/components/ItineraryItem.vue';
    import { SERVER_TIME_FORMAT, LOCAL_TIME_FORMAT } from "@/constants.js";

    export default {
        props: ['item'],

        components: {
            ItineraryItem,
            DatePicker
        },
        
        data() {
            return {
                is_editing: false,
                show_delete_modal: false,

                datepicker: {
                    config: {
                        format: SERVER_TIME_FORMAT,
                        display_format: LOCAL_TIME_FORMAT
                    }
                }
            }
        },
        
        computed: {
            form() {
                return {
                    ...this.item,
                }
            }
        },

        methods: {
            onSubmit() {
                this.$emit('changed', { ...this.form });
                this.is_editing = false;
            },

            toggleEdit() {
                this.is_editing = !this.is_editing;
            },

            askDeleteItem() {
                this.show_delete_modal = true;
            },
            
            deleteItem() {
                this.$emit('deleted', { ...this.form });
            }
        }
    }
</script>

<style scoped lang="scss">
    form {
        margin-bottom: 10px;
    }

    .form-group {
        margin-bottom: 0;
    }

    .alert {
        margin-top: 5px;
    }

    textarea {
        margin-bottom: 10px;
    }

    .edit-itinerary-item__form-wrapper {
        
    }
</style>